import Vue from 'vue';
import store from '@/store';
import pixAxios from '@/axios/pixAxios.js';

import Console from '@/shared/console';

import genericTableService from '@/services/genericConfig/genericTable.utils.js';
import documentUtils from '@/services/document/document.utils.js';

import tableIdConst from '@/consts/tableId.const.js';

const rolesModule = {
  namespaced: true,

  state: {
    selectedRole: null,
    rolesTableConfig: [],
    rolesTableData: null,
    rolesList: [],
  },

  actions: {
    async fetchRolesTableData({ commit }, { SearchTerm = null, ...tablePaginationConfig }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        const { data } = await pixAxios.post('/api/Users/SearchRoles', { SearchTerm, IncludeProfiles: true, ...tablePaginationConfig });
        commit('setRolesTableData', data);
      } catch (err) {
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },
    async fetchRolesTableConfig({ commit }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        const config = await genericTableService.getGenericTableCall(tableIdConst.ROLES);
        commit('setRolesTableConfig', config);
      } catch (err) {
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },
    async fetchRolesList({ commit }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        const { data } = await pixAxios.get('/api/Users/GetListRolesCombo');
        const mappedData = data.map(({ Role, RoleDesc, RoleRowId }) => ({ ValueDesc: `[${Role}] ${RoleDesc}`, ValueCode: RoleRowId }));
        commit('setRolesList', mappedData);
      } catch (err) {
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },

    async registerRole(_, { newRoleInfo: { Role, RoleDesc } }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        await pixAxios.post('/api/Users/AddRole', {
          RoleRowId: '00000000-0000-0000-0000-000000000000',
          Role,
          RoleDesc,
          RoleList: [],
          NumProfiles: 0,
          AudTime: new Date(),
          AudUsu: store.getters['authModule/UserName'],
        });
        Vue.toasted.global.pixSuccess('Role created');
      } catch (err) {
        Vue.toasted.global.pixError(err);
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },

    async updateRole(_, { updatedRoleInfo }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        await pixAxios.put('/api/Users/UpdateRole', updatedRoleInfo);
        Vue.toasted.global.pixSuccess('Role updated');
      } catch (err) {
        Vue.toasted.global.pixError(err);
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },

    async deleteRole(_, { selectedRole: { RoleRowId } }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        await pixAxios.delete(`/api/Users/DeleteRole?req=${RoleRowId}`);
        Vue.toasted.global.pixSuccess('Role deleted');
      } catch (err) {
        Vue.toasted.global.pixError(err);
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },

    async fetchRolesTableExcel(_, { SearchTerm = null }) {
      store.dispatch('loadingOverlayModule/setIsLoading', true);
      try {
        const document = await pixAxios.get('/api/Users/GetListRolesExcel', {
          SearchTerm,
        });
        documentUtils.exportDocument(document, 'roles');
      } catch (err) {
        Console.log(err);
      } finally {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
      }
    },

    clearState({ commit }) {
      commit('setSelectedRole', null);
      commit('setRolesTableConfig', []);
      commit('setRolesTableData', null);
      commit('setRolesList', []);
    },

    selectRole({ commit }, { selectedRole }) {
      commit('setSelectedRole', selectedRole);
    },

    clearStore({ commit }) {
      commit('setSelectedRole', null);
      commit('setRolesTableConfig', []);
      commit('setRolesTableData', null);
      commit('setRolesList', []);
    },
  },

  mutations: {
    setRolesList(state, payload) {
      Vue.set(state, 'rolesList', payload);
    },
    setRolesTableData(state, payload) {
      Vue.set(state, 'rolesTableData', payload);
    },
    setRolesTableConfig(state, payload) {
      Vue.set(state, 'rolesTableConfig', payload);
    },
    setSelectedRole(state, payload) {
      Vue.set(state, 'selectedRole', payload);
    },
  },

  getters: {
    rolesTablePagination(state) {
      return state.rolesTableData;
    },
    rolesTableData(state) {
      return state.rolesTableData?.rows;
    },
  },
};

export default rolesModule;
